export function replaceDotWithComma(str: string) {

    return str.replace(/\./g, ",").replace(/,(\d)(?=\d+)/g, ",$1");
}